export type RoleFilter = 'editors' | 'public-users' | 'all';

interface RoleFilterToggleProps {
  value: RoleFilter;
  onChange: (value: RoleFilter) => void;
}

const OPTIONS: { value: RoleFilter; label: string }[] = [
  { value: 'editors', label: 'Editors' },
  { value: 'public-users', label: 'Public Users' },
  { value: 'all', label: 'All' },
];

// Feature 011 — three-value segmented control. Default = 'editors' (FR-040).
export function RoleFilterToggle({ value, onChange }: RoleFilterToggleProps) {
  return (
    <div
      role="tablist"
      aria-label="Filter by role"
      className="inline-flex rounded-md shadow-sm border border-line-strong overflow-hidden"
    >
      {OPTIONS.map(option => {
        const selected = value === option.value;
        return (
          <button
            key={option.value}
            type="button"
            role="tab"
            aria-selected={selected}
            onClick={() => onChange(option.value)}
            className={`px-4 py-2 text-sm font-medium focus:outline-none ${
              selected
                ? 'bg-primary-600 text-white'
                : 'bg-card text-ink hover:bg-cream'
            }`}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
